import { render, staticRenderFns } from "./TrainingListItem.vue?vue&type=template&id=2f9c55a8&scoped=true"
import script from "./TrainingListItem.vue?vue&type=script&lang=js"
export * from "./TrainingListItem.vue?vue&type=script&lang=js"
import style0 from "./TrainingListItem.vue?vue&type=style&index=0&id=2f9c55a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c55a8",
  null
  
)

export default component.exports